module.exports = __webpack_public_path__ + "static/media/UweEbert.513e14c5.jpg";